import React, { useEffect } from 'react'
import ShippingManagement from '../components/Shipping/ShippingManagement'
import { shippingAddressServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

function ShippingAddressManagementBuild({
  configureTrack,
  epid,
  widgetToken,
  hasWidgetToken = true,
  ...rest
}) {
  useEffect(() => {
    configureTrack?.({
      eventName: 'ShippingAddressManagement init',
      widget: 'ShippingAddressManagement',
      pageType: 'ShippingAddressManagement',
    })
  }, [configureTrack])

  return (
    <ShippingManagement
      epid={epid}
      widgetToken={widgetToken}
      hasWidgetToken={hasWidgetToken}
      {...rest}
    />
  )
}

const ShippingManagementWidget = injectWidget({
  widget: ShippingAddressManagementBuild,
  serviceConfig: shippingAddressServiceConfig,
  isCarryTokenOnHeader: true,
  enableActiveWidget: true,
})

export default ShippingManagementWidget
